import { Stack, Typography } from "@mui/material";

export const ShowInfo = ({ label, value }) => {
  return (
    <Stack spacing={1} direction="row">
      <Typography variant="body1">{label}: </Typography>
      <Typography variant="body1">{value}</Typography>
    </Stack>
  );
};
